var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1CD93C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.333 18.6668H21.333V10.6668C21.333 10.3132 21.1925 9.97407 20.9425 9.72402C20.6924 9.47397 20.3533 9.3335 19.9997 9.3335C19.6461 9.3335 19.3069 9.47397 19.0569 9.72402C18.8068 9.97407 18.6663 10.3132 18.6663 10.6668V18.6668H10.6663C10.3127 18.6668 9.97358 18.8073 9.72353 19.0574C9.47348 19.3074 9.33301 19.6465 9.33301 20.0002C9.33301 20.3538 9.47348 20.6929 9.72353 20.943C9.97358 21.193 10.3127 21.3335 10.6663 21.3335H18.6663V29.3335C18.6663 29.6871 18.8068 30.0263 19.0569 30.2763C19.3069 30.5264 19.6461 30.6668 19.9997 30.6668C20.3533 30.6668 20.6924 30.5264 20.9425 30.2763C21.1925 30.0263 21.333 29.6871 21.333 29.3335V21.3335H29.333C29.6866 21.3335 30.0258 21.193 30.2758 20.943C30.5259 20.6929 30.6663 20.3538 30.6663 20.0002C30.6663 19.6465 30.5259 19.3074 30.2758 19.0574C30.0258 18.8073 29.6866 18.6668 29.333 18.6668Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.635d87ffc8c2b5b130fa16bff73df432.svg";
export { ForwardRef as ReactComponent };